// extracted by mini-css-extract-plugin
export default {"TextColor":"PYG07CRp"};